export const SWITCH_FILTER_SELECTED: string = 'SWITCH_FILTER_SELECTED'
export const switchFilterSelected = (selected: string[]) => ({
  type: SWITCH_FILTER_SELECTED,
  data: selected,
});
